module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "match-detail"
  }, [_c('header', {
    staticClass: "page-header"
  }, [_c('h2', {
    staticClass: "page-header__title"
  }, [_vm._v(_vm._s(_vm.pageTitle))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "detail-form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formRules,
      "disabled": _vm.formDisabled,
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "section-card"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("基础信息")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "matchType"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _c('span', [_vm._v("赛事类型")])]), _vm._v(" "), _c('el-select', {
    staticClass: "same-width-input",
    attrs: {
      "placeholder": "请选择赛事类型",
      "disabled": _vm.formDisabled
    },
    model: {
      value: (_vm.form.matchType),
      callback: function($$v) {
        _vm.$set(_vm.form, "matchType", $$v)
      },
      expression: "form.matchType"
    }
  }, _vm._l((_vm.matchTypeOptions), function(opt) {
    return _c('el-option', {
      key: opt.value,
      attrs: {
        "label": opt.label,
        "value": opt.value
      }
    })
  }), 1)], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赛事标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "same-width-input",
    attrs: {
      "placeholder": "请输入赛事标题，不超过30个字",
      "maxlength": 30,
      "show-word-limit": "",
      "disabled": _vm.formDisabled
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "signTime"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _c('span', [_vm._v("报名时间")])]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "disabled": _vm.formDisabled,
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "picker-options": _vm.signTimePickerOptions
    },
    on: {
      "change": _vm.onSignTimePickerChange
    },
    model: {
      value: (_vm.form.signTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "signTime", $$v)
      },
      expression: "form.signTime"
    }
  })], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _c('span', [_vm._v("比赛时间")])]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "disabled": _vm.formDisabled,
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "picker-options": _vm.matchTimePickerOptions
    },
    on: {
      "change": _vm.onMatchTimePickerChange
    },
    model: {
      value: (_vm.form.endTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "endTime", $$v)
      },
      expression: "form.endTime"
    }
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "section-card"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("比赛规则")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "finishType"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _c('span', [_vm._v("比赛要求")])]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "disabled": _vm.formDisabled
    },
    model: {
      value: (_vm.form.finishType),
      callback: function($$v) {
        _vm.$set(_vm.form, "finishType", $$v)
      },
      expression: "form.finishType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("需一次性完成")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("可累计完成")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-tip"
  }, [_vm._v("\n            一次性完成：指参赛的组别需通过单次运动完成；可累计完成：指参赛组别可多次运动累计完成\n          ")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "runTypes"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _c('span', [_vm._v("跑步类型")])]), _vm._v(" "), _c('div', {
    staticClass: "run-types"
  }, [_c('el-checkbox-group', {
    attrs: {
      "disabled": _vm.formDisabled
    },
    on: {
      "change": _vm.onRunTypesChange
    },
    model: {
      value: (_vm.form.runTypes),
      callback: function($$v) {
        _vm.$set(_vm.form, "runTypes", $$v)
      },
      expression: "form.runTypes"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": 1,
      "disabled": true
    }
  }, [_vm._v("户外跑")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("校园跑")])], 1)], 1)], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "groups"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _c('span', [_vm._v("参赛组别")])]), _vm._v(" "), _c('div', {
    staticClass: "group-list"
  }, [_vm._l((_vm.form.groups), function(group, index) {
    return _c('div', {
      key: index,
      staticClass: "group-item"
    }, [_c('el-select', {
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "placeholder": "类型",
        "disabled": _vm.formDisabled
      },
      on: {
        "change": function($event) {
          return _vm.onGroupTypeChange(group)
        }
      },
      model: {
        value: (group.type),
        callback: function($$v) {
          _vm.$set(group, "type", $$v)
        },
        expression: "group.type"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "公里数",
        "value": 1
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "消耗",
        "value": 2
      }
    })], 1), _vm._v(" "), (group.type === 1) ? _c('el-select', {
      staticStyle: {
        "width": "120px",
        "margin-left": "10px"
      },
      attrs: {
        "placeholder": "公里数类型",
        "disabled": _vm.formDisabled
      },
      on: {
        "change": function($event) {
          return _vm.onDistanceTypeChange(group)
        }
      },
      model: {
        value: (group.distanceType),
        callback: function($$v) {
          _vm.$set(group, "distanceType", $$v)
        },
        expression: "group.distanceType"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "自定义",
        "value": 0
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "半马",
        "value": 1
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "全马",
        "value": 2
      }
    })], 1) : _vm._e(), _vm._v(" "), (group.type === 1 && group.distanceType === 0) ? _c('el-input', {
      staticStyle: {
        "width": "120px",
        "margin-left": "10px"
      },
      attrs: {
        "placeholder": "请输入公里数",
        "disabled": _vm.formDisabled
      },
      on: {
        "input": function (val) { return _vm.onDistanceInput(val, group); },
        "blur": function($event) {
          return _vm.onDistanceBlur(group)
        }
      },
      nativeOn: {
        "keydown": function($event) {
          return _vm.onDistanceKeydown.apply(null, arguments)
        },
        "paste": function($event) {
          $event.preventDefault();
          return (function (e) { return _vm.onDistancePaste(e, group); }).apply(null, arguments)
        },
        "compositionend": function($event) {
          return (function (e) { return _vm.onDistanceCompositionEnd(e, group); }).apply(null, arguments)
        }
      },
      model: {
        value: (group.distance),
        callback: function($$v) {
          _vm.$set(group, "distance", $$v)
        },
        expression: "group.distance"
      }
    }) : _vm._e(), _vm._v(" "), (group.type === 1 && group.distanceType !== 0) ? _c('span', {
      staticStyle: {
        "width": "120px",
        "margin-left": "10px",
        "display": "inline-block"
      }
    }, [_vm._v(_vm._s(group.distance) + "公里")]) : _vm._e(), _vm._v(" "), (group.type === 2) ? _c('el-input', {
      staticStyle: {
        "width": "120px",
        "margin-left": "10px"
      },
      attrs: {
        "placeholder": "请输入消耗值",
        "disabled": _vm.formDisabled
      },
      on: {
        "input": function (val) { return _vm.onCalorieInput(val, group); }
      },
      nativeOn: {
        "keydown": function($event) {
          return _vm.onCalorieKeydown.apply(null, arguments)
        },
        "paste": function($event) {
          $event.preventDefault();
          return (function (e) { return _vm.onCaloriePaste(e, group); }).apply(null, arguments)
        },
        "compositionend": function($event) {
          return (function (e) { return _vm.onCalorieCompositionEnd(e, group); }).apply(null, arguments)
        }
      },
      model: {
        value: (group.distance),
        callback: function($$v) {
          _vm.$set(group, "distance", $$v)
        },
        expression: "group.distance"
      }
    }) : _vm._e(), _vm._v(" "), (group.type === 2) ? _c('span', {
      staticStyle: {
        "margin-left": "4px",
        "color": "#606266",
        "line-height": "40px",
        "flex-shrink": "0"
      }
    }, [_vm._v("千卡")]) : _vm._e(), _vm._v(" "), (index > 0 && !_vm.formDisabled) ? _c('el-button', {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.removeGroup(index)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()], 1)
  }), _vm._v(" "), (!_vm.formDisabled) ? [_c('el-button', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus",
      "disabled": _vm.form.groups.length >= 6
    },
    on: {
      "click": _vm.addGroup
    }
  }, [_vm._v("新增组别")]), _vm._v(" "), (_vm.form.groups.length >= 6) ? _c('span', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#999"
    }
  }, [_vm._v("最多添加6组")]) : _vm._e()] : _vm._e()], 2)], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "平均配速要求",
      "prop": "paceType"
    }
  }, [_c('el-radio-group', {
    staticClass: "pace-radio-group",
    attrs: {
      "disabled": _vm.formDisabled
    },
    model: {
      value: (_vm.form.paceType),
      callback: function($$v) {
        _vm.$set(_vm.form, "paceType", $$v)
      },
      expression: "form.paceType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("限制")])], 1), _vm._v(" "), (_vm.form.paceType === 1) ? _c('div', {
    staticClass: "pace-limit-row"
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": _vm.formDisabled,
      "min": 0,
      "max": 59,
      "controls-position": "right",
      "placeholder": "分钟"
    },
    model: {
      value: (_vm.form.paceMin),
      callback: function($$v) {
        _vm.$set(_vm.form, "paceMin", $$v)
      },
      expression: "form.paceMin"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pace-sep"
  }, [_vm._v("分")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": _vm.formDisabled,
      "min": 0,
      "max": 59,
      "controls-position": "right",
      "placeholder": "秒数"
    },
    model: {
      value: (_vm.form.paceMax),
      callback: function($$v) {
        _vm.$set(_vm.form, "paceMax", $$v)
      },
      expression: "form.paceMax"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pace-sep"
  }, [_vm._v("秒/公里 —")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": _vm.formDisabled,
      "min": 0,
      "max": 59,
      "controls-position": "right",
      "placeholder": "分钟"
    },
    model: {
      value: (_vm.form.paceMinEnd),
      callback: function($$v) {
        _vm.$set(_vm.form, "paceMinEnd", $$v)
      },
      expression: "form.paceMinEnd"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pace-sep"
  }, [_vm._v("分")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": _vm.formDisabled,
      "min": 0,
      "max": 59,
      "controls-position": "right",
      "placeholder": "秒数"
    },
    model: {
      value: (_vm.form.paceMaxEnd),
      callback: function($$v) {
        _vm.$set(_vm.form, "paceMaxEnd", $$v)
      },
      expression: "form.paceMaxEnd"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pace-sep"
  }, [_vm._v("秒/公里")])], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    ref: "packageSection",
    staticClass: "section-card"
  }, [_c('div', {
    staticClass: "section-title"
  }, [(_vm.mode !== 'view') ? _c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v("套餐配置\n        "), (!_vm.formDisabled) ? [_c('el-button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus",
      "disabled": _vm.form.packages.length >= 10
    },
    on: {
      "click": _vm.addPackage
    }
  }, [_vm._v("新增套餐")]), _vm._v(" "), (_vm.form.packages.length >= 10) ? _c('span', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#999"
    }
  }, [_vm._v("最多添加10个")]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (_vm.packagesError) ? _c('div', {
    staticClass: "packages-error-tip"
  }, [_vm._v("\n        " + _vm._s(_vm.packagesError) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "package-list"
  }, _vm._l((_vm.form.packages), function(pkg, index) {
    return _c('div', {
      key: pkg.id,
      staticClass: "package-item"
    }, [_c('div', {
      staticClass: "package-header"
    }, [(_vm.form.packages.length > 0 && !_vm.formDisabled) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.removePackage(index)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('package-config', {
      attrs: {
        "package-data": pkg,
        "package-index": index,
        "readonly": _vm.formDisabled,
        "images-editable": _vm.imagesEditable
      },
      on: {
        "relate-prize": _vm.onRelatePrize,
        "preview-image": _vm.previewImage
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "section-card"
  }, [_c('div', {
    staticClass: "section-body section-indent"
  }, [_c('div', {
    staticClass: "detail-section"
  }, [_c('div', {
    staticClass: "detail-title-row"
  }, [_c('span', {
    staticClass: "detail-title"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("赛事封面图")]), _vm._v(" "), _c('span', {
    staticClass: "detail-title-hint"
  }, [_vm._v("尺寸建议370*180，最大300KB，优先webp次选png")])]), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('el-form-item', {
    staticClass: "match-cover-form-item",
    attrs: {
      "prop": "coverUrl",
      "label": "",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "match-upload-block"
  }, [_c('div', {
    staticClass: "match-dynamic-upload-list"
  }, [_c('div', {
    staticClass: "match-dynamic-upload-bezel match-dynamic-upload-bezel--210"
  }, [(_vm.imagesEditable) ? _c('SUpload', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1",
      "headers": _vm.uploadAuthHeaders,
      "accept": "image/*",
      "type": "drag",
      "size": 300,
      "show-file-list": false
    },
    model: {
      value: (_vm.form.coverUrl),
      callback: function($$v) {
        _vm.$set(_vm.form, "coverUrl", $$v)
      },
      expression: "form.coverUrl"
    }
  }) : (_vm.form.coverUrl) ? _c('div', {
    staticClass: "match-upload-preview-box match-upload-preview-box--view",
    on: {
      "click": function($event) {
        return _vm.previewImage(_vm.form.coverUrl)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.form.coverUrl,
      "alt": ""
    }
  })]) : _c('div', {
    staticClass: "match-upload-empty-view"
  }, [_vm._v("暂无图片")])], 1)])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detail-section"
  }, [_c('div', {
    staticClass: "detail-title-row"
  }, [_c('span', {
    staticClass: "detail-title"
  }, [_vm._v("赛事详情")])]), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('div', {
    staticClass: "detail-stack"
  }, [_c('div', {
    staticClass: "detail-upload-field"
  }, [_c('div', {
    staticClass: "detail-upload-field__label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("赛事主视觉"), _c('span', {
    staticClass: "detail-title-hint detail-title-hint--after-label"
  }, [_vm._v("尺寸建议370*568，最大300KB，优先webp次选png")])]), _vm._v(" "), _c('div', {
    staticClass: "detail-upload-field__body"
  }, [_c('el-form-item', {
    staticClass: "detail-upload-inner-form-item",
    attrs: {
      "prop": "visualUrl",
      "label": "",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "match-upload-block"
  }, [_c('div', {
    staticClass: "match-dynamic-upload-list"
  }, [_c('div', {
    staticClass: "match-dynamic-upload-bezel match-dynamic-upload-bezel--210"
  }, [(_vm.imagesEditable) ? _c('SUpload', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1",
      "headers": _vm.uploadAuthHeaders,
      "accept": "image/*",
      "type": "drag",
      "size": 300,
      "show-file-list": false
    },
    model: {
      value: (_vm.form.visualUrl),
      callback: function($$v) {
        _vm.$set(_vm.form, "visualUrl", $$v)
      },
      expression: "form.visualUrl"
    }
  }) : (_vm.form.visualUrl) ? _c('div', {
    staticClass: "match-upload-preview-box match-upload-preview-box--view",
    on: {
      "click": function($event) {
        return _vm.previewImage(_vm.form.visualUrl)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.form.visualUrl,
      "alt": ""
    }
  })]) : _c('div', {
    staticClass: "match-upload-empty-view"
  }, [_vm._v("\n                            暂无图片\n                          ")])], 1)])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detail-upload-field"
  }, [_c('div', {
    staticClass: "detail-upload-field__label detail-upload-field__label--wrap"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("主色调背景（比赛规则、赛事状态、我的进度三个模块的背景图）"), _c('span', {
    staticClass: "detail-title-hint detail-title-hint--after-label"
  }, [_vm._v("尺寸建议370*588，最大300KB，优先webp次选png")])]), _vm._v(" "), _c('div', {
    staticClass: "detail-upload-field__body"
  }, [_c('el-form-item', {
    staticClass: "detail-upload-inner-form-item",
    attrs: {
      "prop": "mainColorBgUrl",
      "label": "",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "match-upload-block"
  }, [_c('div', {
    staticClass: "match-dynamic-upload-list"
  }, [_c('div', {
    staticClass: "match-dynamic-upload-bezel match-dynamic-upload-bezel--210"
  }, [(_vm.imagesEditable) ? _c('SUpload', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1",
      "headers": _vm.uploadAuthHeaders,
      "accept": "image/*",
      "type": "drag",
      "size": 300,
      "show-file-list": false
    },
    model: {
      value: (_vm.form.mainColorBgUrl),
      callback: function($$v) {
        _vm.$set(_vm.form, "mainColorBgUrl", $$v)
      },
      expression: "form.mainColorBgUrl"
    }
  }) : (_vm.form.mainColorBgUrl) ? _c('div', {
    staticClass: "match-upload-preview-box match-upload-preview-box--view",
    on: {
      "click": function($event) {
        return _vm.previewImage(_vm.form.mainColorBgUrl)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.form.mainColorBgUrl,
      "alt": ""
    }
  })]) : _c('div', {
    staticClass: "match-upload-empty-view"
  }, [_vm._v("\n                            暂无图片\n                          ")])], 1)])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detail-upload-field"
  }, [_c('div', {
    staticClass: "detail-upload-field__label detail-upload-field__label--wrap"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("赛事介绍（包括赛事导语、套餐介绍、奖品细节、赛事规则等）"), _c('span', {
    staticClass: "detail-title-hint detail-title-hint--after-label"
  }, [_vm._v("建议宽度：402px，jpg/png")])]), _vm._v(" "), _c('div', {
    staticClass: "detail-upload-field__body"
  }, [_c('el-form-item', {
    staticClass: "detail-upload-inner-form-item",
    attrs: {
      "prop": "introUrl",
      "label": "",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "match-upload-block"
  }, [_c('div', {
    staticClass: "match-dynamic-upload-list"
  }, [_c('div', {
    staticClass: "match-dynamic-upload-bezel match-dynamic-upload-bezel--multi"
  }, [(_vm.imagesEditable) ? [_c('div', {
    staticClass: "match-upload-thumbs"
  }, [_vm._l((_vm.introUrlList), function(url, idx) {
    return _c('div', {
      key: idx,
      staticClass: "match-upload-thumb match-upload-thumb--view",
      on: {
        "click": function($event) {
          return _vm.previewImage(url)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": url,
        "alt": ""
      }
    }), _vm._v(" "), _c('el-button', {
      staticClass: "match-upload-close",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeIntroImage(idx)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-cross"
    })])], 1)
  }), _vm._v(" "), (_vm.introUrlList.length < 10) ? _c('div', {
    staticClass: "match-upload-thumb"
  }, [(_vm.matchImageUploading === 'introUrl') ? _c('div', {
    staticClass: "match-upload-loading"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" "), _c('span', [_vm._v("上传中…")])]) : _c('el-upload', {
    staticClass: "match-upload-dragger",
    attrs: {
      "drag": "",
      "action": "#",
      "auto-upload": false,
      "show-file-list": false,
      "on-change": _vm.onIntroChange,
      "accept": "image/*"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  })])])], 1) : _vm._e()], 2)] : [_c('div', {
    staticClass: "match-upload-thumbs"
  }, _vm._l((_vm.introUrlList), function(url, idx) {
    return _c('div', {
      key: idx,
      staticClass: "match-upload-thumb match-upload-thumb--view",
      on: {
        "click": function($event) {
          return _vm.previewImage(url)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": url,
        "alt": ""
      }
    })])
  }), 0), _vm._v(" "), (!_vm.introUrlList.length) ? _c('div', {
    staticClass: "match-upload-empty-view"
  }, [_vm._v("\n                              暂无图片\n                            ")]) : _vm._e()]], 2)])])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-section"
  }, [_c('div', {
    staticClass: "detail-title-row detail-title-row--share"
  }, [_c('span', {
    staticClass: "detail-title"
  }, [_vm._v("分享站外配置")])]), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('div', {
    staticClass: "detail-stack"
  }, [_c('div', {
    staticClass: "detail-upload-field"
  }, [_c('div', {
    staticClass: "detail-upload-field__label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _c('span', [_vm._v("封面图")]), _vm._v(" "), _c('span', {
    staticClass: "detail-title-hint detail-title-hint--after-label"
  }, [_vm._v("尺寸建议50*50，最大50KB，优先SVG其次png")])]), _vm._v(" "), _c('div', {
    staticClass: "detail-upload-field__body"
  }, [_c('el-form-item', {
    staticClass: "detail-upload-inner-form-item",
    attrs: {
      "prop": "shareCoverUrl",
      "label": "",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "match-upload-block"
  }, [_c('div', {
    staticClass: "match-dynamic-upload-list"
  }, [_c('div', {
    staticClass: "match-dynamic-upload-bezel match-dynamic-upload-bezel--210"
  }, [(_vm.mode !== 'view') ? _c('SUpload', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1",
      "headers": _vm.uploadAuthHeaders,
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "show-file-list": false
    },
    model: {
      value: (_vm.form.shareCoverUrl),
      callback: function($$v) {
        _vm.$set(_vm.form, "shareCoverUrl", $$v)
      },
      expression: "form.shareCoverUrl"
    }
  }) : (_vm.form.shareCoverUrl) ? _c('div', {
    staticClass: "match-upload-preview-box match-upload-preview-box--view",
    on: {
      "click": function($event) {
        return _vm.previewImage(_vm.form.shareCoverUrl)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.form.shareCoverUrl,
      "alt": ""
    }
  })]) : _c('div', {
    staticClass: "match-upload-empty-view"
  }, [_vm._v("\n                            暂无图片\n                          ")])], 1)])])])], 1)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "detail-share-text-row",
    attrs: {
      "prop": "shareTitle",
      "label": "",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "detail-share-field-row"
  }, [_c('span', {
    staticClass: "detail-upload-field__label detail-share-field-row__label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("标题")]), _vm._v(" "), _c('el-input', {
    staticClass: "same-width-input detail-share-field-row__input",
    attrs: {
      "placeholder": "不超过50字",
      "maxlength": 50,
      "show-word-limit": "",
      "disabled": _vm.formDisabled
    },
    model: {
      value: (_vm.form.shareTitle),
      callback: function($$v) {
        _vm.$set(_vm.form, "shareTitle", $$v)
      },
      expression: "form.shareTitle"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "detail-share-text-row",
    attrs: {
      "label": "",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "detail-share-field-row"
  }, [_c('span', {
    staticClass: "detail-upload-field__label detail-share-field-row__label"
  }, [_vm._v("描述（非必填）")]), _vm._v(" "), _c('el-input', {
    staticClass: "same-width-input detail-share-field-row__input",
    attrs: {
      "placeholder": "不超过20字",
      "maxlength": 20,
      "show-word-limit": "",
      "disabled": _vm.formDisabled
    },
    model: {
      value: (_vm.form.shareDesc),
      callback: function($$v) {
        _vm.$set(_vm.form, "shareDesc", $$v)
      },
      expression: "form.shareDesc"
    }
  })], 1)])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-card"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("发布")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form-item', {
    staticClass: "publish-type-form-item",
    attrs: {
      "label": "",
      "label-width": "0px",
      "prop": "publishType"
    }
  }, [_c('el-radio-group', {
    staticClass: "publish-radio-group",
    attrs: {
      "disabled": _vm.formDisabled
    },
    model: {
      value: (_vm.form.publishType),
      callback: function($$v) {
        _vm.$set(_vm.form, "publishType", $$v)
      },
      expression: "form.publishType"
    }
  }, [_c('div', {
    staticClass: "publish-option"
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("仅预览")]), _vm._v(" "), _c('span', {
    staticClass: "publish-desc"
  }, [_vm._v("（生成H5链接，用于校对信息，APP端不显示）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "publish-option"
  }, [_c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("正式发布")]), _vm._v(" "), _c('span', {
    staticClass: "publish-desc"
  }, [_vm._v("APP端直接显示，所有人可见")])], 1)])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "footer-actions"
  }, [_c('el-button', {
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(_vm._s(_vm.mode === "view" ? "返回" : "取消"))]), _vm._v(" "), (_vm.imagesEditable) ? [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? "保存修改" : "创建赛事"))])] : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "图片预览",
      "close-on-click-modal": true,
      "modal-append-to-body": false,
      "width": "800px",
      "center": ""
    },
    model: {
      value: (_vm.imagePreviewVisible),
      callback: function($$v) {
        _vm.imagePreviewVisible = $$v
      },
      expression: "imagePreviewVisible"
    }
  }, [_c('img', {
    staticClass: "preview-image",
    attrs: {
      "src": _vm.previewImageUrl
    }
  })]), _vm._v(" "), _c('prize-select-dialog', {
    attrs: {
      "visible": _vm.prizeDialogVisible,
      "existing-prizes": _vm.currentPackagePrizes
    },
    on: {
      "update:visible": function($event) {
        _vm.prizeDialogVisible = $event
      },
      "confirm": _vm.onPrizeConfirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ca2a804!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/onlineMatch/matchDetail.vue
// module id = 1016
// module chunks = 0